import React from "react";

export const API_TABS = [
  { id: "text-to-text", label: "Text-to-Text API" },
  { id: "text-to-speech", label: "Text-to-Speech API" },
  { id: "speech-to-text", label: "Speech-to-Text API" },
  { id: "speech-translations", label: "Speech Translations API" },
];

const ApiTabsNav = ({ activeTab, onTabChange }) => {
  return (
    <div className="w-full flex items-center justify-start sm:justify-center overflow-x-auto custom-scrollbar py-3 px-1">
      <div className="flex items-center gap-3 sm:gap-4 min-w-max">
        {API_TABS.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`px-5 py-3 sm:px-6 sm:py-3.5 rounded-2xl text-sm sm:text-base font-bold transition-all duration-200 select-none ${
                isActive
                  ? "bg-[#EF8702] text-white shadow-sm border border-[#EF8702]"
                  : "bg-white text-black border border-[#E0E4E2] hover:border-gray-300 hover:bg-gray-50/80 shadow-[0_1px_2px_rgba(0,0,0,0.02)]"
              }`}
              aria-selected={isActive}
              role="tab"
            >
              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ApiTabsNav;
